import Carousel from "../components/Carousel"

import * as React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import IntroBlurb from '../components/IntroBlurb';
import PDBlurb from '../components/PDBlurb';
import BrotherhoodBlurb from '../components/BrotherhoodBlurb';
import CSBlurb from '../components/CSBlurb';
import Paper from '@mui/material/Paper';

export default function HomeBody() {
    return (
        <>
            <Container justifyContent="center" maxWidth='lg'>
        <br></br>
        <br></br>
          <Grid container rowSpacing={0} columnSpacing={12}>
          <Grid xs={6} md={.5}>
            </Grid>
            <Grid xs={6} md={7}>
              <Paper elevation={5} style={{padding: 25}}>
                <IntroBlurb />
              </Paper>
            </Grid>
            <Grid xs={6} md={.5}>
            </Grid>
            <Grid xs={6} md={4}>
              <Paper elevation={8}>
                <Carousel />
              </Paper>
            
            </Grid>
            <Grid xs={6} md={12}>
              <br></br><br></br>
            </Grid>
            <Grid xs={6} md={.5}>
            </Grid>
            <Grid xs={6} md={3.5}>
              <Paper elevation={5} style={{padding: 25}}>
                <PDBlurb />
              </Paper>
            </Grid>
            <Grid xs={6} md={.5}>
            </Grid>
            <Grid xs={6} md={3.5}>
              <Paper elevation={5} style={{padding: 25}}>
                <BrotherhoodBlurb />
              </Paper>
            </Grid>
            <Grid xs={6} md={.5}>
            </Grid>
            <Grid xs={6} md={3.5}>
              <Paper elevation={5} style={{padding: 25}}>
                <CSBlurb />
              </Paper>
            </Grid>
          </Grid>
        <br></br>
      </Container>
        </>
    );
  }
